import styled from '@emotion/styled'

import { SUB_COLOR } from '@/constants/colors'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  /* flex: 1; */
  min-width: 0;
  width: 100%;
`

export const CouponImage = styled.img`
  width: 100%;
  aspect-ratio: 1;
  object-fit: contain;
  background-color: #fff;
  width: 78.5px;
  height: 78.5px;
  padding: 12.6px;
  border-radius: 30px;
`

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const RankText = styled.span`
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.06px;
  color: ${SUB_COLOR};
`

export const AmountText = styled.span`
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
  color: white;
`
